import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@carvana/showroom-modal';
import { Spinner } from '@carvana/showroom-spinner';
import DuoCheckIcon from '../../../assets/DuoCheckIcon';
import BankPaymentError from '../bank-payment-error';
import BridgecrestCustomError from '../bridgecrest-custom-error';
import {
  ModalContentWrapper,
  Description,
  DetailsRow,
  Column,
  ColumnTitle,
  ColumnData,
  ConfirmButton,
} from './OneTimePaymentDialog.styles';
import { formatCurrency } from '../../../utils/CurrencyUtils';
import { getOneTimePaymentDetails } from '../../../ducks/selectors';
import { setOneTimePaymentDetails } from '../../../ducks/actions';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const OneTimePaymentDialog = ({
  openModal,
  isSubmitting,
  togglePaymentSuccessErrorModal,
}: any) => {
  const { trackEvent } = useDualEventTracking();

  const dispatch = useDispatch();

  const oneTimePaymentDetails = useSelector(getOneTimePaymentDetails);

  const hasErrors = oneTimePaymentDetails?.isError;
  const isLoading =
    isSubmitting ||
    !oneTimePaymentDetails ||
    (oneTimePaymentDetails?.withdrawalAmount <= 0 && !hasErrors);

  useEffect(() => {
    if (openModal && !hasErrors) {
      trackEvent('Confirmation Screen');
    }
  }, [openModal]);

  const handleClick = () => {
    togglePaymentSuccessErrorModal(false);
    const { vehicleId } = oneTimePaymentDetails;
    dispatch(
      setOneTimePaymentDetails({
        isError: false,
        errorCode: '',
        errorMessage: '',
        cvnaPaymentAmountDue: -1,
        withdrawalAmount: -1,
        vehicleId,
      })
    );
    trackEvent('confirm_payment_done_button_tap');
  };

  const errorHandleClick = () => {
    trackEvent('confirm_payment_failure_button_tap');
    togglePaymentSuccessErrorModal(false);
  };

  let renderContent;

  let headerText = 'Payment Scheduling';

  if (isLoading) {
    renderContent = <Spinner />;
  } else {
    headerText = 'Payment Scheduled';
    const { withdrawalAmount, selectedDate } = oneTimePaymentDetails;
    renderContent = (
      <>
        <DuoCheckIcon />
        <Description>
          Payment schedule confirmation for your Bridgecrest account
        </Description>
        <DetailsRow>
          <Column>
            <ColumnTitle>Amount</ColumnTitle>
            <ColumnData>{formatCurrency(withdrawalAmount)}</ColumnData>
          </Column>
          <Column>
            <ColumnTitle>Scheduled For</ColumnTitle>
            <ColumnData>{selectedDate}</ColumnData>
          </Column>
        </DetailsRow>
        <ConfirmButton onClick={handleClick}>Close Window</ConfirmButton>
      </>
    );
  }

  if (hasErrors) {
    const { errorCode, errorMessage } = oneTimePaymentDetails;
    if (errorCode === 'BridgecrestGraphQLErrorException') {
      return (
        <BridgecrestCustomError
          id="bridgecrestError"
          isOpen={openModal}
          header="MAKE PAYMENT"
          title="UNABLE TO SCHEDULE PAYMENT"
          message={errorMessage}
          closeModal={() => togglePaymentSuccessErrorModal(false)}
        />
      );
    }

    return (
      <BankPaymentError
        id="bankPaymentError"
        openModal={openModal}
        toggleModal={errorHandleClick}
      />
    );
  }

  return (
    <Modal
      headerText={headerText}
      mode="light"
      isOpen={openModal}
      closeModal={handleClick}
    >
      <ModalContentWrapper>{renderContent}</ModalContentWrapper>
    </Modal>
  );
};
export default OneTimePaymentDialog;
